import { API_CONFIG } from '@/config/api'
import { baseService } from './baseService'
import type { ProjectParticipant, CreateProjectParticipantRequest } from './projectTypes'

export interface Participant {
  id: number
  email: string
  first_name: string
  last_name: string
  full_name: string
  is_active: boolean
  date_joined: string
}

export class ParticipantService {
  async getUsers(): Promise<Participant[]> {
    const response = await baseService.get<{ results: Participant[] }>(API_CONFIG.ENDPOINTS.ACCOUNTS.USERS)
    return response.data.results
  }

  async getProjectParticipants(projectId: number): Promise<ProjectParticipant[]> {
    try {
      const response = await baseService.get<{ results: ProjectParticipant[] }>(`/project-participants/?project=${projectId}`)
      return response.data.results || []
    } catch (error) {
      console.error('Error getting project participants:', error)
      return []
    }
  }

  async createProjectParticipant(participantData: CreateProjectParticipantRequest): Promise<ProjectParticipant> {
    const response = await baseService.post<ProjectParticipant>('/project-participants/', participantData)
    return response.data
  }

  async deleteProjectParticipant(participantId: number): Promise<void> {
    await baseService.delete(`/project-participants/${participantId}/`)
  }

  async getParticipantQuestionnaireResponse(participantId: number): Promise<any> {
    const response = await baseService.get(`/project-participants/${participantId}/questionnaire_response/`)
    return response.data
  }
}

export const participantService = new ParticipantService()
